import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 3c1.92 0 3.7 .601 5.16 1.626l-5.16 7.374z","fill":"currentColor","stroke":"none","key":"svg-0"}],["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0","key":"svg-1"}]]

const IconPercentage10 = createReactComponent('outline', 'percentage-10', 'Percentage10', __iconNode);

export default IconPercentage10;